module.exports = __webpack_public_path__ + "static/media/comgate.042e133c.png";